import CRUD from './genericCRUD'

const route = 'packhouse_blocks'

/**
 * @param {import("axios").AxiosInstance} instance
 */
export default function packhouseBlocks(instance) {
	return {
		/**
		 * CRUD creates the Create, Get, Update and GetALL endpoints;
		 */
		...CRUD(instance, route),

		/**
		 * @param {string} number
		 * @param {number} phaseId
		 * @param {number} varietyId
		 * @param {number} farmId
		 * @param { string } puc
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		getAllFiltered: (
			number,
			phaseId,
			varietyId,
			farmId,
			puc,
			pageNumber,
			pageSize,
			config = {}
		) => {
			const params =
				!!pageNumber && !!pageSize
					? `pageNumber=${pageNumber}&pageSize=${pageSize}&`
					: ''
			const numberParam = number ? `number=${number}&` : ''
			const phaseParam = phaseId ? `phaseId=${phaseId}&` : ''
			const varietyParam = varietyId ? `varietyId=${varietyId}&` : ''
			const farmParam = farmId ? `farmId=${farmId}&` : ''
			const pucParam = puc ? `puc=${puc}&` : ''

			return instance.get(
				`${route}?${params}${numberParam}${phaseParam}${varietyParam}${farmParam}${pucParam}`,
				config
			)
		},

		/**
		 * @param {{ name: string }} body
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		update: (body, config = {}) => {
			return instance.put(`${route}`, body, config)
		}
	}
}
